import { useTranslation } from "react-i18next";

// CSS
import "./languageselector.css";

// Icons
import israelIcon from "../../assets/images/flags/israel.png";

/** ממשק מוצר בעברית בלבד — תצוגת שפה ללא מעבר לאנגלית */
function LanguageSelector() {
  const { t } = useTranslation();

  return (
    <div className="language-selector">
      <div className="dropdown-toggle" role="status" aria-label={t("languages.currentlanguage")}>
        <img src={israelIcon} alt="" className="flag-icon" />
        {t("languages.currentlanguage")}
      </div>
    </div>
  );
}

export default LanguageSelector;
